import type { ComponentType } from 'react'
import { useStore } from '../state/store'
import { useT } from '../i18n'
import type { ModeId } from '../core/types'
import {
  IconFlow,
  IconGrid,
  IconHatch,
  IconPath,
  IconPhyllo,
  IconRings,
  IconScatter,
  IconSpiral,
  IconVoronoi,
} from './icons'

export const MODES: { id: ModeId; label: string; icon: ComponentType<{ size?: number }> }[] = [
  { id: 'grid', label: 'Grid', icon: IconGrid },
  { id: 'scatter', label: 'Scatter', icon: IconScatter },
  { id: 'spiral', label: 'Spiral', icon: IconSpiral },
  { id: 'concentric', label: 'Rings', icon: IconRings },
  { id: 'fibonacci', label: 'Phyllo', icon: IconPhyllo },
  { id: 'crosshatch', label: 'Hatch', icon: IconHatch },
  { id: 'voronoi', label: 'Voronoi', icon: IconVoronoi },
  { id: 'path', label: 'Path', icon: IconPath },
  { id: 'flowlines', label: 'Flow', icon: IconFlow },
]

export function modeLabel(id: ModeId): string {
  return MODES.find((m) => m.id === id)?.label ?? id
}

const MODE_KEYS: Record<ModeId, string> = {
  grid: 'mode.grid',
  scatter: 'mode.scatter',
  spiral: 'mode.spiral',
  concentric: 'mode.rings',
  fibonacci: 'mode.phyllo',
  crosshatch: 'mode.hatch',
  voronoi: 'mode.voronoi',
  path: 'mode.path',
  flowlines: 'mode.flow',
}

export function ModeRail() {
  const mode = useStore((s) => s.doc.layout.mode)
  const commit = useStore((s) => s.commit)
  const t = useT()
  return (
    <nav className="mode-rail" aria-label="Layout mode">
      {MODES.map((m, i) => (
        <button
          key={m.id}
          className={mode === m.id ? 'mode-btn active' : 'mode-btn'}
          title={`${t(MODE_KEYS[m.id], m.label)} (${i + 1})`}
          aria-pressed={mode === m.id}
          onClick={() =>
            commit(`Switch to ${m.label}`, (d) => {
              d.layout.mode = m.id
            })
          }
        >
          <m.icon size={18} />
          <span>{t(MODE_KEYS[m.id], m.label)}</span>
        </button>
      ))}
    </nav>
  )
}
